<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ userInfo.displayName }}</p>
      <small>καλώς ήρθατε</small>
    </div>

    <!-- start::dropdown -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <!-- start::user avatar -->
      <div class="con-img ml-3">
        <img v-if="userInfo.photoURL" key="onlineImg" :src="userInfo.photoURL" alt="user-img" width="40"
             height="40" class="rounded-full shadow-md cursor-pointer block"/>
      </div>
      <!-- end::user avatar -->

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click.prevent="displayCurrentUserPopUp">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Προφίλ</span>
          </li>

          <router-link tag="li" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                       :to="{name: 'page-support'}">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Υποστήριξη</span>
          </router-link>
          <vs-divider class="m-1"/>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click.prevent="removeOrphanLinks">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Εργασίες συντήρηση</span>
          </li>
          <vs-divider class="m-1"/>

          <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Αποσύνδεση</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <!-- end::dropdown -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {'name': '', photoURL: require("@/assets/images/portrait/small/img-avatar-1.png")}
    }
  },
  methods: {
    removeOrphanLinks () {
      let vm = this
      vm.$store.dispatch('removeOrphanLinks').then(() => {
        vm.$vs.notify({
          color: 'success',
          title: 'Εργασίες συντήρηση',
          text: 'Η βελτιστοποίηση πινάκων ολοκληρώθηκε με επιτυχία!'
        })
      })
    },
    logout() {
      //1. Remove token from the local storage
      localStorage.removeItem('accessToken')
      // 2. Set logged in user to an empty object.
      this.$store.dispatch('userSetter', {});

      // If user clicks on logout -> redirect to login.
      this.$router.push('/login').catch(() => {
      })
    },
    displayCurrentUserPopUp() {
      // 1. Display the modal
      this.$store.dispatch('displayUserPopUp', true)
      // 2. Change modal title dynamically
      this.$store.dispatch('setUserPopUpTitle', 'Επεξεργασία χρήστη')
      // 3. Fetch the current user.
        this.$store.dispatch('fetchUser', this.userInfo.uid)
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  }
}
</script>
